/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Index file for user dashboard
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import HeaderFooter from '../common/openPages/HeaderFooterwithCookies';

// eslint-disable-next-line no-unused-vars
const styles = (theme) => ({
  root: {
    minWidth: 275,
    padding: '2rem',
    marginTop: 100,
  },
  header: {
    textAlign: 'center',
  },
});

class Home extends Component {
  render() {
    const { classes } = this.props;
    return (
      <HeaderFooter>
        <Grid
          container
          justify='center'
          style={{
            backgroundColor: '#F2F2F2',
          }}
        >
          <Grid item xs={10} sm={8} md={5}>
            <Card className={classes.root}>
              <CardContent style={{ paddingTop: 0 }}>
                <Grid container direction='column'>
                  <Grid item xs={12} md={12} className={classes.header}>
                    <Typography variant='h4' className={classes.text}>
                      Welcome to Schrocken
                    </Typography>
                    <Typography
                      variant='body2'
                      style={{ fontSize: '1rem', padding: '0.75rem 0' }}
                    >
                      Get Started with our Blockchain!!
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </HeaderFooter>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);
